<!--<splash-screen></splash-screen>-->

<router-outlet></router-outlet>

<app-spinner *ngIf="showLoader"></app-spinner>
